import { render } from "./CharacterNotFound.vue?vue&type=template&id=1d409434"
import script from "./CharacterNotFound.vue?vue&type=script&lang=js"
export * from "./CharacterNotFound.vue?vue&type=script&lang=js"
script.render = render

export default script